import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

const errText = (d) =>
  typeof d === "string" ? d : Array.isArray(d) ? d.map((e) => e?.msg).filter(Boolean).join(" ") : "Κάτι πήγε στραβά";

export const ChangePasswordDialog = ({ open, onOpenChange }) => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const reset = () => {
    setCurrent("");
    setNext("");
    setConfirm("");
  };

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) {
      toast.error("Ο νέος κωδικός και η επιβεβαίωση δεν ταιριάζουν");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", {
        current_password: current,
        new_password: next,
      });
      toast.success("Ο κωδικός άλλαξε επιτυχώς");
      reset();
      onOpenChange(false);
    } catch (err) {
      toast.error(errText(err.response?.data?.detail) || "Αποτυχία αλλαγής κωδικού");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) reset(); onOpenChange(v); }}>
      <DialogContent className="sm:max-w-[400px]" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle>Αλλαγή κωδικού</DialogTitle>
          <DialogDescription>
            Εισάγετε τον τρέχοντα κωδικό σας και τον νέο κωδικό (τουλάχιστον 6 χαρακτήρες).
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="cp-current">Τρέχων κωδικός</Label>
            <Input
              id="cp-current"
              type="password"
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
              required
              autoComplete="current-password"
              data-testid="current-password-input"
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="cp-new">Νέος κωδικός</Label>
            <Input
              id="cp-new"
              type="password"
              value={next}
              onChange={(e) => setNext(e.target.value)}
              required
              minLength={6}
              autoComplete="new-password"
              data-testid="new-password-input"
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="cp-confirm">Επιβεβαίωση νέου κωδικού</Label>
            <Input
              id="cp-confirm"
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
              minLength={6}
              autoComplete="new-password"
              data-testid="confirm-password-input"
            />
          </div>
          <Button type="submit" disabled={saving} className="w-full" data-testid="change-password-submit">
            {saving ? "Αποθήκευση…" : "Αλλαγή κωδικού"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
